// extracted by mini-css-extract-plugin
export var textInput = "_d2-0";